export default __webpack_public_path__ + "static/media/6.5bb7bdbb.png";